module.exports = __webpack_public_path__ + "img/aiIcon-lpr.4cbefb39.svg";